import { useState, useMemo } from "react";
import type { ProjectSummary } from "@/api/client";

export function useProjectFiltering(projects: ProjectSummary[]) {
  const [archiveSearch, setArchiveSearch] = useState("");
  const [sortBy, setSortBy] = useState<"alpha" | "date">("date");
  const [sortAsc, setSortAsc] = useState(false);

  const filteredProjects = useMemo(() => {
    const q = archiveSearch.trim().toLowerCase();
    const list = q
      ? projects.filter((p) => {
          const inName = p.name.toLowerCase().includes(q);
          const inNotes = (p.description_preview ?? "").toLowerCase().includes(q);
          const inTags = (p.tags ?? []).some((t) => t.toLowerCase().includes(q));
          const inLoc = (p.location ?? "").toLowerCase().includes(q);
          return inName || inNotes || inTags || inLoc;
        })
      : [...projects];
    list.sort((a, b) => {
      let cmp = 0;
      if (sortBy === "alpha") {
        cmp = a.name.localeCompare(b.name, "fr");
      } else {
        const da = a.created_at ? new Date(a.created_at).getTime() : 0;
        const db = b.created_at ? new Date(b.created_at).getTime() : 0;
        cmp = da - db;
      }
      return sortAsc ? cmp : -cmp;
    });
    return list;
  }, [projects, archiveSearch, sortBy, sortAsc]);

  return {
    archiveSearch,
    setArchiveSearch,
    sortBy,
    setSortBy,
    sortAsc,
    setSortAsc,
    filteredProjects,
  };
}
